function resetLocationBootstrapCache({ trackerMap, userMap } = {}) {
  if (trackerMap && typeof trackerMap.clear === 'function') {
    trackerMap.clear()
  }

  if (userMap && typeof userMap.clear === 'function') {
    userMap.clear()
  }
}

function resolveLocationRequestMode({ trackerMapSize = 0, overrideOnlyOnline } = {}) {
  const isFirstLoad = trackerMapSize === 0

  return {
    isFirstLoad,
    onlyOnline: overrideOnlyOnline !== undefined ? overrideOnlyOnline : !isFirstLoad,
  }
}

function markMissingTrackersOffline({ trackerMap, onlineTrackerLocations } = {}) {
  if (!trackerMap || typeof trackerMap.forEach !== 'function') {
    return
  }

  const onlineSssids = new Set(
    (onlineTrackerLocations || [])
      .filter((location) => location && location.tracker && location.tracker.sssid != null)
      .map((location) => String(location.tracker.sssid))
  )

  trackerMap.forEach((location, sssid) => {
    if (!onlineSssids.has(String(sssid)) && location && location.lastLoc) {
      location.lastLoc.online = false
    }
  })
}

module.exports = {
  resetLocationBootstrapCache,
  resolveLocationRequestMode,
  markMissingTrackersOffline,
}
